import {
  latestProcedurePresentation,
  reduceAgentEvents,
  type ProcedurePresentation,
  type RunActivity,
} from '@/frontend/features/AgentChats/events/agentEvents'
import type { AgentChatMessage } from '@/frontend/pages/Dashboard/AgentChats/types'

export function latestProcedureForConversation(
  messages: AgentChatMessage[],
  liveActivity: RunActivity | null,
  persistedDraft: ProcedurePresentation | null = null,
): ProcedurePresentation | null {
  const live = latestProcedurePresentation(liveActivity)
  const persisted = [...messages].reverse().find((message) => (
    message.role === 'assistant' &&
    latestProcedurePresentation(reduceAgentEvents(message.activity_events || [])) !== null
  ))
  const previousFromEvents = persisted
    ? latestProcedurePresentation(reduceAgentEvents(persisted.activity_events || []))
    : null
  const previous = persistedDraft || previousFromEvents

  if (!live) return previous
  if (!previous || live.draft) return live

  // A start event describes the new operation before its result carries the
  // next snapshot. Keep the last durable diagram visible while truthfully
  // updating the status/spinner for the in-flight operation.
  return {
    ...previous,
    ...live,
    title: live.title || previous.title,
    draft: previous.draft,
    review: live.review || previous.review,
    process: live.process || previous.process,
  }
}
